/// <reference types="vite/client" />
var env;
var NODE_ENV;
var FILESTACK_API_KEY = 'A0HwTllqOQMGhtATyx9euz';
var S3_BUCKET = 'infl-staging-files';
var PRIVATE_S3_BUCKET = 'infl-staging-priv-files'; // AI-GEN - Cursor and GPT4
// In vite mode, process.env.NODE_ENV exists but process is undefined
// In nextJs mode, 'process.env.TEST' is text replaced to whatever the value is in env variables and process is defined

if (typeof process !== 'undefined') {
  var _process$env$NODE_ENV;

  NODE_ENV = (_process$env$NODE_ENV = "production") !== null && _process$env$NODE_ENV !== void 0 ? _process$env$NODE_ENV : '';
  if (process.env.NEXT_PUBLIC_FILESTACK_API_KEY) FILESTACK_API_KEY = process.env.NEXT_PUBLIC_FILESTACK_API_KEY;
  S3_BUCKET = true ? 'infl-prod-files' : "infl-staging-files";
  PRIVATE_S3_BUCKET = true ? 'infl-prod-priv-files' : "infl-staging-priv-files"; // AI-GEN - Cursor and GPT4
  // AI-GEN START - Cursor GPT4

  if (process.env.NEXT_PUBLIC_DEPLOY_ENV) {
    S3_BUCKET = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'production' ? 'infl-prod-files' : "infl-staging-files";
    PRIVATE_S3_BUCKET = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'production' ? 'infl-prod-priv-files' : "infl-staging-priv-files";
  } // AI-GEN END

} else if (import.meta !== undefined) {
  env = import.meta.env;
  NODE_ENV = env.MODE;
  if (env.VITE_PUBLIC_FILESTACK_API_KEY) FILESTACK_API_KEY = env.VITE_PUBLIC_FILESTACK_API_KEY;
  S3_BUCKET = env.MODE === 'production' ? 'infl-prod-files' : "infl-staging-files";
  PRIVATE_S3_BUCKET = env.MODE === 'production' ? 'infl-prod-priv-files' : "infl-staging-priv-files"; // AI-GEN - Cursor and GPT4
  // AI-GEN START - Cursor GPT4

  if (env.VITE_PUBLIC_DEPLOY_ENV) {
    S3_BUCKET = env.VITE_PUBLIC_DEPLOY_ENV === 'production' ? 'infl-prod-files' : "infl-staging-files";
    PRIVATE_S3_BUCKET = env.VITE_PUBLIC_DEPLOY_ENV === 'production' ? 'infl-prod-priv-files' : "infl-staging-priv-files";
  } // AI-GEN END

} else {
  throw 'No env found';
}

export { FILESTACK_API_KEY, NODE_ENV, S3_BUCKET, PRIVATE_S3_BUCKET }; // AI-GEN - Cursor and GPT4